<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-3">
<h1 class="title">FLIGHT THROUGH THE AGES</h1>
<p class="title1">A 50th Anniversary Tribute to the Guild of Aviation Artists</p>
<p class="author">GUILD OF AVIATION ARTISTS</p>
<div class="img_container">
<img alt="image" src="images/Img_3_001.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003_Title.vue?8cc7cdd4